// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'vuetify/dist/vuetify.min.css';
import 'v-calendar/lib/v-calendar.min.css';
import VCalendar from 'v-calendar';
import Vuetify from 'vuetify';
import theme from '@/env/ThemeConfig';
import VueSweetalert2 from 'vue-sweetalert2';

import Vue from 'vue';
import App from './App';
import router from './router';

Vue.use(VueSweetalert2);
Vue.use(Vuetify, { theme });
Vue.use(VCalendar, {
  locale: 'pt-BR',
  componentPrefix: 'vc',
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js